import React from 'react';

import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { PartnerManagerData } from 'types/partnerManager';

type Props = {
  partnerId: number;
  parnerManagerData: PartnerManagerData;
  onViewClientDetails(clientId: number): void;
};

export const PartnerManagerClientsScreen = (props: Props) => {
  const { parnerManagerData, onViewClientDetails: viewClientDetails } = props;

  const {
    shared: sharedDitctionary,
    partnerManager: { clientsScreen: ownDictionary },
  } = useIntlDictionary();

  const { partnerManagerClients } = parnerManagerData;

  return (
    <>
      {partnerManagerClients.length === 0 && (
        <SidebarModalSectionComponent
          content={
            <TextComponent size="m" color="secondary">
              {ownDictionary.fallbackText}
            </TextComponent>
          }
          actions={null}
          navigation={null}
        />
      )}
      {partnerManagerClients.map((partnerManagerClient) => (
        <SidebarModalSectionComponent
          key={partnerManagerClient.id}
          content={
            <SmallTableWrapperComponent>
              <SmallTableRowComponent>
                <TextComponent>{ownDictionary.organizationLabel}</TextComponent>
                <TextComponent>
                  <ClickControlComponent
                    onClick={() => viewClientDetails(partnerManagerClient.id)}
                  >
                    <TextComponent color="accent">
                      {partnerManagerClient.organization}
                    </TextComponent>
                  </ClickControlComponent>
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>{ownDictionary.contactLabel}</TextComponent>
                <TextComponent>
                  {ownDictionary.contactText(partnerManagerClient)}
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>
                  {ownDictionary.registrationDateLabel}
                </TextComponent>
                <TextComponent>
                  {sharedDitctionary.dates.calendarDateWithTime(
                    new Date(partnerManagerClient.registrationDate)
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>
                  {ownDictionary.subscriptionEnabledLabel}
                </TextComponent>
                <TextComponent>
                  {ownDictionary.subscriptionStatusText(
                    partnerManagerClient.subscriptionActive
                  )}
                </TextComponent>
              </SmallTableRowComponent>
            </SmallTableWrapperComponent>
          }
          actions={null}
        />
      ))}
    </>
  );
};
